/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicDirectToBuyRpc
 */
import * as References from './PublicDirectToBuyRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicDirectToBuyRpc#createDirectToBuyConfig
 */
export const CREATE_DIRECT_TO_BUY_CONFIG_MUTATION_FIELD_NAME = 'com_hubspot_buying_rpc_PublicDirectToBuyRpc_createDirectToBuyConfig';
export const CREATE_DIRECT_TO_BUY_CONFIG_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_DIRECT_TO_BUY_CONFIG_MUTATION_FIELD_NAME,
  args: ['productConfigurations', 'browserLocale', 'preferredCountryCode', 'currencyCode', 'expirationDate', 'activeAt', 'terms'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createDirectToBuyConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicDirectToBuyRpc#getDirectToBuyConfig
 */
export const GET_DIRECT_TO_BUY_CONFIG_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicDirectToBuyRpc_getDirectToBuyConfig';
export const GET_DIRECT_TO_BUY_CONFIG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DIRECT_TO_BUY_CONFIG_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getDirectToBuyConfigRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicDirectToBuyRpc#getDirectToBuyConfigV2
 */
export const GET_DIRECT_TO_BUY_CONFIG_V2_QUERY_FIELD_NAME = 'com_hubspot_buying_rpc_PublicDirectToBuyRpc_getDirectToBuyConfigV2';
export const GET_DIRECT_TO_BUY_CONFIG_V2_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DIRECT_TO_BUY_CONFIG_V2_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getDirectToBuyConfigV2Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});